import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export const PathForPdf = ({ children }) => {
    return (_jsx("span", { style: {
            marginRight: 4,
            fontSize: "0.75em",
            lineHeight: "1em",
        }, children: children }));
};
export const TitleWithPathForPdf = ({ title, pathForPdf, }) => {
    return (_jsxs("div", { style: { wordBreak: "break-word" }, children: [pathForPdf ? _jsx(PathForPdf, { children: pathForPdf }) : null, title] }));
};
//# sourceMappingURL=PathForPdf.js.map